import { ProtectedRoute } from '../../../router/protectedrouter';
import MainLayout from '../../../components/layouts/MainLayoutPage';

import RequestNewScanVAPT from '../components/RequestNewScan.jsx';
import RequestReportPage from '../components/RequestReportPage';
import UploadVulnerabilities from '../components/UploadVulnerabilities';
import UploadPDFPage from '../components/UploadPDFPage';
import ViewReportVAPT from '../components/SummaryReport';
import ViewPDFPage from '../components/ViewPDFPage';
import EditVulnerability from '../components/EditVulnerability';
import SingleAlertPage from '../components/dashboard/SingleAlertPage';
import DashboardPage from '../components/dashboard/OverAllDashboard'
import AlertsPage from '../components/dashboard/AlertsPage'
import PartnerDashboardPage from '../components/PartnerDashboardPage'
import ViewReportPage from '../components/ViewReport';
import OverAllDashboard from '../components/overalldashboard/OverAllDashboard';
import ConfigureDimensions from '../components/ConfigureDimensions';
import DimensionWeightageConfigure from '../components/DimensionWeightageConfigure';

const base_url="/vapt";
const routes = [
    {
        path: `${base_url}`,
        children:[
            {
                path : `requestnewscan`,
                element : <ProtectedRoute> <MainLayout> <RequestNewScanVAPT/> </MainLayout> </ProtectedRoute>,
                name : "RequestNewScan",
            },
            {
                path: `request-reports`,
                element: <ProtectedRoute> <MainLayout> <RequestReportPage /> </MainLayout> </ProtectedRoute>,
                name: "requestreports",
            },
            {
                path: `configure-dimensions-vapt`,
                element: <ProtectedRoute> <MainLayout> <ConfigureDimensions /> </MainLayout> </ProtectedRoute>,
                name: "configuredimensionsVAPT",
            },
            {
                path: `dimensions-weightage-vapt`,
                element: <ProtectedRoute> <MainLayout> <DimensionWeightageConfigure /> </MainLayout> </ProtectedRoute>,
                name: "dimensionsweightageVAPT",
            },
            {
                path: `upload-vulnerabilities`,
                element: <ProtectedRoute> <MainLayout> <UploadVulnerabilities /> </MainLayout> </ProtectedRoute>,
                name: "uploadvulnerabilities",
            },
            {
                path: `upload-pdf`,
                element: <ProtectedRoute> <MainLayout> <UploadPDFPage /> </MainLayout> </ProtectedRoute>,
                name: "uploadPDF",
            },
            {
                path: `pdfreport`,
                element: <ProtectedRoute><MainLayout> <ViewReportVAPT/> </MainLayout></ProtectedRoute>,
                name: "summaryreport",
            },
            {
                path: `view-reports`,
                element : <ProtectedRoute><MainLayout> <ViewReportPage/> </MainLayout></ProtectedRoute>,
                name: "viewvaptreport"
            },
            {
                path: `view-pdf`,
                element: <ProtectedRoute><MainLayout> <ViewPDFPage/> </MainLayout></ProtectedRoute>,
                name: "viewpdf",
            },
            {
                path: `vulnerability/:id`,
                element: <ProtectedRoute><MainLayout> <SingleAlertPage/> </MainLayout></ProtectedRoute>,
                name: "singlealertpage",
            },
            {
                path: `edit-vulnerability/:id`,
                element: <ProtectedRoute><MainLayout> <EditVulnerability/> </MainLayout></ProtectedRoute>,
                name: "singlealertpage", 
            },
            {
              //  path: `dashboard/:category?`,
                 path: `dashboard/over-all`,
                element: <ProtectedRoute><MainLayout> <DashboardPage /> </MainLayout></ProtectedRoute>,
                name: "dashboard",
            },
            {
                  path: `dashboard/overall`,
                  element: <ProtectedRoute><MainLayout> <OverAllDashboard/> </MainLayout></ProtectedRoute>,
                  name: "overalldashboard",
            },
            {
                path: `dashboard/:dimension?`,
                element: <ProtectedRoute><MainLayout> <DashboardPage /> </MainLayout></ProtectedRoute>,
                name: "dashboard",
            },
            {
                path: `category-threats-dashboard/category-threats`,
                element: <ProtectedRoute><MainLayout> <AlertsPage/> </MainLayout></ProtectedRoute>,
                name: "alertspage",
            },
            {
                path: `partner-dashboard`,
                element: <ProtectedRoute><MainLayout> <PartnerDashboardPage /> </MainLayout></ProtectedRoute>,
                name: "partnerdashboard",
            },
        ]
    },
]

export default routes;